import { createContext, ReactNode, useCallback, useContext, useMemo, useState } from "react";

const IdentityVerificationPanelContext = createContext<{
  isOpen: boolean;
  open: () => void;
  close: () => void;
}>({
  isOpen: false,
  open: () => {},
  close: () => {},
});

export const IdentityVerificationPanelProvider = ({ children }: { children: ReactNode }) => {
  const [isOpen, setIsOpen] = useState(false);

  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);
  // Stable open/close identities alone aren't enough — the object literal
  // passed to `value` is otherwise still rebuilt every render, which is what
  // actually breaks memoization for any consumer (e.g. a React.memo'd
  // message list) that receives open/close as props.
  const value = useMemo(() => ({ isOpen, open, close }), [isOpen, open, close]);

  return (
    <IdentityVerificationPanelContext.Provider value={value}>
      {children}
    </IdentityVerificationPanelContext.Provider>
  );
};

export const useIdentityVerificationPanel = () => useContext(IdentityVerificationPanelContext);
